import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LayoutDashboard, FileText, Building2, Landmark, Globe, Handshake, LogOut, BarChart3, AlertTriangle, FileSpreadsheet, CalendarDays, Wallet, Menu, X, Archive } from "lucide-react";

const nav = [
  { to: "/dashboard", label: "Panel", icon: LayoutDashboard, id: "nav-dashboard" },
  { to: "/cases", label: "Vize İşlemleri", icon: FileText, id: "nav-cases" },
  { to: "/calendar", label: "Takvim", icon: CalendarDays, id: "nav-calendar" },
  { to: "/alerts", label: "Uyarılar", icon: AlertTriangle, id: "nav-alerts" },
  { to: "/payments-all", label: "Tüm Ödemeler", icon: Wallet, id: "nav-payments" },
  { to: "/import", label: "İçe Aktar", icon: FileSpreadsheet, id: "nav-import" },
  { to: "/suppliers", label: "Tedarikçiler", icon: Building2, id: "nav-suppliers" },
  { to: "/agencies", label: "Aracı Kurumlar", icon: Handshake, id: "nav-agencies" },
  { to: "/countries", label: "Ülkeler", icon: Globe, id: "nav-countries" },
  { to: "/banks", label: "Banka Hesapları", icon: Landmark, id: "nav-banks" },
  { to: "/stats", label: "İstatistik", icon: BarChart3, id: "nav-stats" },
  { to: "/backups", label: "Yedekler", icon: Archive, id: "nav-backups" },
];

const Sidebar = ({ user, logout, onNav }) => (
  <>
    <div className="p-6 border-b border-zinc-200">
      <div className="font-display font-black text-2xl tracking-tight">Vize<span className="text-[#0033cc]">Panel</span></div>
      <div className="label-overline mt-1">Danışmanlık OS</div>
    </div>
    <nav className="p-3 flex-1 overflow-y-auto">
      {nav.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          onClick={onNav}
          data-testid={n.id}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm mb-1 transition-colors ${
              isActive ? "bg-zinc-950 text-white" : "text-zinc-700 hover:bg-zinc-100"
            }`
          }
        >
          <n.icon size={16} />
          <span>{n.label}</span>
        </NavLink>
      ))}
    </nav>
    <div className="p-3 border-t border-zinc-200">
      <div className="flex items-center gap-3 px-2 py-2">
        {user?.picture ? <img src={user.picture} alt="" className="w-8 h-8 rounded-full" /> : <div className="w-8 h-8 rounded-full bg-zinc-200" />}
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium truncate">{user?.name}</div>
          <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
        </div>
      </div>
      <button data-testid="logout-btn" onClick={logout} className="mt-2 w-full flex items-center gap-2 px-3 py-2 text-sm text-zinc-600 hover:bg-zinc-100 rounded-md transition-colors">
        <LogOut size={14} /> Çıkış
      </button>
    </div>
  </>
);

export default function Shell() {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen md:grid md:grid-cols-[240px_1fr]">
      {/* Mobile top bar */}
      <div className="md:hidden sticky top-0 z-30 bg-white border-b border-zinc-200 flex items-center justify-between px-4 py-3">
        <button onClick={() => setMobileOpen(true)} data-testid="mobile-menu-btn" className="p-2 -ml-2 hover:bg-zinc-100 rounded"><Menu size={20} /></button>
        <div className="font-display font-black text-xl tracking-tight">Vize<span className="text-[#0033cc]">Panel</span></div>
        <div className="w-10" />
      </div>

      {/* Desktop sidebar */}
      <aside className="hidden md:flex md:flex-col border-r border-zinc-200 bg-white sticky top-0 h-screen">
        <Sidebar user={user} logout={logout} />
      </aside>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-zinc-950/40" onClick={() => setMobileOpen(false)} data-testid="mobile-overlay">
          <aside className="fixed left-0 top-0 h-full w-72 bg-white flex flex-col shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-end p-2 border-b border-zinc-200"><button onClick={() => setMobileOpen(false)} className="p-2 hover:bg-zinc-100 rounded"><X size={16} /></button></div>
            <Sidebar user={user} logout={logout} onNav={() => setMobileOpen(false)} />
          </aside>
        </div>
      )}

      <main className="min-w-0"><Outlet /></main>
    </div>
  );
}
